module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Marking Group\n        ")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.canCreateMarkingGroup()),
      expression: "canCreateMarkingGroup()"
    }],
    attrs: {
      "slot": "extra",
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.modal.createMarkingGroup = true
      }
    },
    slot: "extra"
  }, [_vm._v("\n                Tambah\n            ")]), _vm._v(" "), [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnTablemarkingGroup,
      "data": _vm.markingGroup
    }
  })]], 2), _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.createMarkingGroup),
      callback: function($$v) {
        _vm.$set(_vm.modal, "createMarkingGroup", $$v)
      },
      expression: "modal.createMarkingGroup"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Marking Group")])], 1), _vm._v(" "), _c('Form', {
    ref: "formMarkingGroup",
    attrs: {
      "model": _vm.formMarkingGroup,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Group Name"
    },
    model: {
      value: (_vm.formMarkingGroup.groupName),
      callback: function($$v) {
        _vm.$set(_vm.formMarkingGroup, "groupName", $$v)
      },
      expression: "formMarkingGroup.groupName"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Select', {
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "multiple": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    model: {
      value: (_vm.formMarkingGroup.markings),
      callback: function($$v) {
        _vm.$set(_vm.formMarkingGroup, "markings", $$v)
      },
      expression: "formMarkingGroup.markings"
    }
  }, _vm._l((_vm.optionMarkings), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingcreateMarkingGroup
    },
    on: {
      "click": _vm.postcreateMarkingGroup
    }
  }, [(!_vm.loadingcreateMarkingGroup) ? _c('span', [_vm._v("Simpan")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], _vm._v(" "), [_c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.modal.editmarkingGroup),
      callback: function($$v) {
        _vm.$set(_vm.modal, "editmarkingGroup", $$v)
      },
      expression: "modal.editmarkingGroup"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Edit Marking Group")])], 1), _vm._v(" "), _c('Form', {
    ref: "formEditMarkingGroup",
    attrs: {
      "model": _vm.formEditMarkingGroup,
      "rules": _vm.ruleValidate
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Group Name",
      "prop": "groupName"
    }
  }, [_c('Input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "placeholder": "Id Group Name"
    },
    model: {
      value: (_vm.formEditMarkingGroup.id),
      callback: function($$v) {
        _vm.$set(_vm.formEditMarkingGroup, "id", $$v)
      },
      expression: "formEditMarkingGroup.id"
    }
  }), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "Group Name"
    },
    model: {
      value: (_vm.formEditMarkingGroup.groupName),
      callback: function($$v) {
        _vm.$set(_vm.formEditMarkingGroup, "groupName", $$v)
      },
      expression: "formEditMarkingGroup.groupName"
    }
  })], 1), _vm._v(" "), _c('Form-item', [_c('Select', {
    attrs: {
      "placeholder": "Ketik Marking",
      "filterable": "",
      "multiple": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.loadingGetMarking
    },
    model: {
      value: (_vm.formEditMarkingGroup.markingSelected),
      callback: function($$v) {
        _vm.$set(_vm.formEditMarkingGroup, "markingSelected", $$v)
      },
      expression: "formEditMarkingGroup.markingSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option, index) {
    return _c('Option', {
      key: index,
      attrs: {
        "value": option.label
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingEditmarkingGroup
    },
    on: {
      "click": _vm.postEditmarkingGroup
    }
  }, [(!_vm.loadingEditmarkingGroup) ? _c('span', [_vm._v("Edit")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1)], _vm._v(" "), _c('Modal', {
    attrs: {
      "ok-text": "Ya",
      "cancel-text": "Tidak"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmDescription = ''
      }
    },
    model: {
      value: (_vm.isModalDelete),
      callback: function($$v) {
        _vm.isModalDelete = $$v
      },
      expression: "isModalDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h4', [_vm._v("GROUP NAME : " + _vm._s(_vm.formDeleteMarkingGroup.groupName))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_c('b', [_vm._v(" MARKING : ")]), _vm._v(" "), _vm._l((_vm.formDeleteMarkingGroup.detail), function(marking, index) {
    return _c('span', [_c('Tag', [_vm._v(_vm._s(marking.markingheadercode))])], 1)
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.formDeleteMarkingGroup.groupName))]), _vm._v(" untuk melanjutkan !")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteMarkingGroup.id),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteMarkingGroup, "id", $$v)
      },
      expression: "formDeleteMarkingGroup.id"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formDeleteMarkingGroup.groupName),
      callback: function($$v) {
        _vm.$set(_vm.formDeleteMarkingGroup, "groupName", $$v)
      },
      expression: "formDeleteMarkingGroup.groupName"
    }
  }), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmDescription),
      callback: function($$v) {
        _vm.confirmDescription = $$v
      },
      expression: "confirmDescription"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.formDeleteMarkingGroup.groupName).toUpperCase() == _vm.confirmDescription.toUpperCase()),
      expression: "(formDeleteMarkingGroup.groupName).toUpperCase() == confirmDescription.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "long": ""
    },
    on: {
      "click": _vm.deleteMarkingGroup
    }
  }, [_vm._v("Hapus")])], 1)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bec45c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/master/MarkingGroup.vue
// module id = 1803
// module chunks = 1